module.exports = __webpack_public_path__ + "f25d053f97047ac7be7bc5646060ad08.png";